import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeyboardArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#1f1f1f",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" })
});
export default SvgKeyboardArrowUp;
